import { Box, Typography, List, ListItem, Grid, Divider } from '@mui/material';
import { useTranslation } from '../../../../commons/useTranslasion';

const CronogramaEtapas = ({ cronograma }: any) => {
  const { translate } = useTranslation();

  return (
    <Box sx={{ padding: 2 }}>
      {["Think", "Plan", "GoToMarket"].map((categoria, indexCategoria) => (
        <Box key={categoria} sx={{ marginBottom: 2 }}>
          <Typography variant="h6" gutterBottom>
            {categoria}
          </Typography>

          <List>
            {cronograma?.[categoria]?.length > 0 ? (
              cronograma[categoria].map((etapa: any, index: number) => (
                <ListItem key={index} sx={{ paddingY: 1 }}>
                  <Grid container>
                    <Grid item xs={8}>
                    <Typography variant="body1">{etapa.nome === 'GoToMarket' ? 'Go To Market' : etapa.nome}</Typography>
                    </Grid>
                    <Grid item xs={4} textAlign="right">
                      <Typography variant="body2" color="textSecondary">
                        {etapa.data}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              ))
            ) : (
              <Typography variant="body2" color="textSecondary">
                {translate("nenhumaEtapaDisponivel")}
              </Typography>
            )}
          </List>

          {indexCategoria < 2 && <Divider sx={{ marginY: 2 }} />}
        </Box>
      ))}
    </Box>
  );
};

export default CronogramaEtapas;
